// extracted by mini-css-extract-plugin
export var skipAnimation = "_k-0";